import { RouteCategoryItem, RouteItem } from '@aipb/frame/model';
import { CONFIG_FRAME } from '@aipb/util/di';

import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { SidebarRouteListComponent } from '../sidebar-route-list/sidebar-route-list.component';

@Component({
  selector: 'fr-sidebar-category-route-list',
  templateUrl: './sidebar-category-route-list.component.html',
  styleUrls: ['./sidebar-category-route-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatExpansionModule, MatIconModule, TranslocoModule, SidebarRouteListComponent]
})
export class SidebarCategoryRouteListComponent {
  // @ts-expect-error foo
  @Input() expanded: boolean;
  @Input() routeCategoryItems: RouteCategoryItem[] = [];

  @Output() removeRoute = new EventEmitter<[evt: MouseEvent, route: RouteItem]>();

  private configFrame = inject(CONFIG_FRAME);

  get isExpanded(): boolean {
    return this.configFrame?.sidebar?.expanded ? this.configFrame.sidebar.expanded : true;
  }

  get isExpandedMulti(): boolean {
    return this.configFrame?.sidebar?.expandedMulti ? this.configFrame.sidebar.expandedMulti : true;
  }
}
